import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function Edit(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox={'0 0 9.915 9.915'} fontSize={'inherit'} {...props}>
      <path
        id="Tracé_60"
        data-name="Tracé 60"
        d="M9.611,1.148,8.769.305a1.044,1.044,0,0,0-1.475,0L.553,7.046a.447.447,0,0,0-.122.228L.009,9.381a.447.447,0,0,0,.526.526l2.107-.421a.447.447,0,0,0,.228-.122L9.611,2.623h0A1.044,1.044,0,0,0,9.611,1.148ZM2.334,8.636,1.017,8.9l.263-1.317L6.767,2.1,7.821,3.149ZM8.979,1.991l-.527.527L7.4,1.464,7.926.937a.149.149,0,0,1,.211,0l.843.843a.149.149,0,0,1,0,.211"
        transform="translate(-0.001 0)"
        fill="#333"
      />
    </SvgIcon>
  );
}
